import { ApiError, createApiClient, Result, wrapper } from "../base";
import DashboardCardDO = App.Data.DashboardCardDO;
import DashboardDO = App.Data.DashboardDO;
import DocumentDO = App.Data.Explorer.DocumentDO;
import ExplorerAiSettingsDO = App.Data.ExplorerAiSettingsDO;
import AnnotatedEventDO = App.Data.AnnotatedEventDO;
const basePath = `ai-report`;
const baseClient = createApiClient();

export default class {
	public generateDashboardRapport(
		dashboard: DashboardDO,
		cards: DashboardCardDO[],
		prompt: string,
	) {

			return baseClient.post(`${basePath}/generate-dashboard-rapport`, {
				dashboard_id: dashboard.id,
				prompt: prompt,
				cards: cards,
			}, {
			timeout: 60000
		})
	}

	public async generateExplorerRapport(
		aiDocument: DocumentDO,
		aiSettings: ExplorerAiSettingsDO,
		onToken: (token: any) => void,
		onComplete?: () => void,
	): Promise<void> {
		const response = await baseClient.post(
			`${basePath}/generate-explorer-rapport`,
			{
				document: aiDocument,
				aiSettings: aiSettings,
			}, {
				responseType: "stream",
				timeout: 60000,
			});

		if (!response.data) throw new Error("No response data");

		const reader = response.data.getReader();
		const decoder = new TextDecoder();
		let done = false;

		while (!done) {
			const { value, done: doneReading } = await reader.read();
			done = doneReading;
			if (value) {
				const chunk = decoder.decode(value, { stream: true });
				console.log(chunk);
				if (chunk.includes("<END_OF_STREAM>")) {
					const parts = chunk.split("<END_OF_STREAM>");
					if (parts[0]) onToken(parts[0]);
					if (onComplete) onComplete();
					break;
				}
				console.log(chunk);
				onToken(chunk);
			}
		}
	}

	public getStatus(
		batchUuid: string,
	) {
		return baseClient.post(`${basePath}/get-status`, {
			batchUuid: batchUuid,

		})
	}

}
